// Generated by Melange

import SongRowModuleCss from "./songRow.module.css";
import * as ReactRouter from "@tanstack/react-router";
import * as Caml_int32 from "melange.js/caml_int32.jsx";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Fx from "../fx/fx.jsx";
import * as LucideReact from "../lucideReact/lucideReact.jsx";
import * as $$Promise from "../promise/promise.jsx";
import * as Router__Link from "../router/link.jsx";
import * as Shared__Button from "./button.jsx";
import * as Shared__CoverArt from "./coverArt.jsx";
import * as Shared__DropdownMenu from "./dropdownMenu.jsx";
import * as Shared__Duration from "./duration.jsx";
import * as Shared__Skeleton from "./skeleton.jsx";
import * as Shared__StarButton from "./starButton.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as StoreFx__RunAsync from "../storeFx/runAsync.jsx";
import * as StoreFx__StartPlaying from "../storeFx/startPlaying.jsx";
import * as StoreFx__TogglePaused from "../storeFx/togglePaused.jsx";
import * as StoreFx__UpdatePlayQueue from "../storeFx/updatePlayQueue.jsx";
import * as Store__Context from "../store/context.jsx";
import Clsx from "clsx";
import * as LucideReact$1 from "lucide-react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = SongRowModuleCss;

const make = React.memo(function (Props) {
  let elementId = Props.elementId;
  let isAlbumView = Props.isAlbumView;
  let isCompilation = Props.isCompilation;
  let isQueueView = Props.isQueueView;
  let primaryArtist = Props.primaryArtist;
  let songId = Props.songId;
  let songIdsToPlay = Props.songIdsToPlay;
  const runAsyncStoreFx = StoreFx__RunAsync.use(undefined);
  const isSelected = ReactRouter.useRouterState({
    select: (function (state) {
      return state.location.hash === elementId;
    })
  });
  const isCurrentInPlayer = Store__Context.useAppStore(function (state) {
    return state.player.currentSongId === songId;
  });
  const paused = Store__Context.useAppStore(function (state) {
    return state.player.paused;
  });
  let tmp = {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Store__Context.Consumer.make, {
            children: (function (song) {
              if (isAlbumView) {
                return JsxRuntime.jsx("span", {
                  children: Stdlib__Option.value(Stdlib__Option.map((function (prim) {
                    return prim;
                  }), Stdlib__Option.bind(song, (function (song) {
                    return song.track;
                  }))), " "),
                  "aria-hidden": true,
                  className: css.trackNumber
                });
              }
              let tmp = {
                className: css.coverArt,
                lazy: true,
                sizes: "3em"
              };
              const tmp$1 = Stdlib__Option.map((function (song) {
                return song.coverArt;
              }), song);
              if (tmp$1 !== undefined) {
                tmp.coverArt = Caml_option.valFromOption(tmp$1);
              }
              return JsxRuntime.jsx(Shared__CoverArt.make, tmp);
            }),
            selector: (function (state) {
              return Stdlib__Option.bind(songId, (function (songId) {
                return Caml_option.undefined_to_opt(state.songs.byId.get(songId));
              }));
            })
          }),
          JsxRuntime.jsx(Store__Context.Consumer.make, {
            children: (function (paused) {
              const arg = null;
              return JsxRuntime.jsxs("div", {
                children: [
                  (function (param) {
                    return Stdlib__Option.value(param, arg);
                  })(Stdlib__Option.map((function (songId) {
                    return JsxRuntime.jsx(Store__Context.Consumer.make, {
                      children: (function (isCurrentInPlayer) {
                        return JsxRuntime.jsx("button", {
                          children: isCurrentInPlayer && !paused ? JsxRuntime.jsx(LucideReact$1.CirclePause, Curry._4(LucideReact.CirclePause.makeProps, undefined, css.playButtonIcon, "none", undefined)) : JsxRuntime.jsx(LucideReact$1.CirclePlay, Curry._4(LucideReact.CirclePlay.makeProps, undefined, css.playButtonIcon, "none", undefined)),
                          "aria-label": "Play",
                          "aria-pressed": isCurrentInPlayer && !paused ? "true" : "false",
                          className: css.playButton,
                          type: "button",
                          onClick: (function (param) {
                            const fx = isCurrentInPlayer ? StoreFx__TogglePaused.make(undefined) : StoreFx__StartPlaying.make(songId, songIdsToPlay, undefined);
                            Curry._1(runAsyncStoreFx, fx).then(function (result) {
                              return Promise.resolve(Stdlib__Result.get_ok(result));
                            });
                          })
                        });
                      }),
                      selector: (function (state) {
                        return state.player.currentSongId === songId;
                      })
                    });
                  }), songId)),
                  JsxRuntime.jsx(Store__Context.Consumer.make, {
                    children: (function (isCurrentInPlayer) {
                      if (isCurrentInPlayer && !paused) {
                        return JsxRuntime.jsx("div", {
                          className: css.nowPlayingIndicator
                        });
                      } else {
                        return null;
                      }
                    }),
                    selector: (function (state) {
                      return state.player.currentSongId === songId;
                    })
                  })
                ],
                className: css.playButtonWrapper
              });
            }),
            selector: (function (state) {
              return state.player.paused;
            })
          })
        ],
        className: css.coverArtAndTrackNumberCol
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Store__Context.Consumer.make, {
          children: (function (song) {
            let tmp;
            if (song !== undefined) {
              let tmp$1;
              if (isAlbumView && (isCompilation || primaryArtist !== song.artist)) {
                const artistId = song.artistId;
                tmp$1 = JsxRuntime.jsx("span", {
                  children: JsxRuntime.jsxs("span", {
                    children: [
                      " – ",
                      React.cloneElement(artistId !== undefined ? JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, undefined, undefined, undefined, undefined, {
                          artistId: artistId
                        }, undefined, "/artist/$artistId", undefined)) : JsxRuntime.jsx("span", {}), {
                        "aria-label": "Artist",
                        children: song.artist
                      })
                    ],
                    "aria-hidden": true
                  }),
                  className: css.subtitle
                });
              } else {
                tmp$1 = null;
              }
              tmp = JsxRuntime.jsxs(React.Fragment, {
                children: [
                  JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps("Title", Caml_option.some(song.title), undefined, elementId, undefined, {
                    albumId: song.albumId
                  }, false, "/album/$albumId", undefined)),
                  tmp$1
                ]
              });
            } else {
              tmp = JsxRuntime.jsx(Shared__Skeleton.make, {
                style: {
                  maxWidth: "10rem"
                }
              });
            }
            let tmp$2;
            if (isAlbumView) {
              tmp$2 = null;
            } else if (song !== undefined) {
              let tmp$3;
              if (primaryArtist === song.artist) {
                tmp$3 = null;
              } else {
                const artistId$1 = song.artistId;
                tmp$3 = JsxRuntime.jsxs(React.Fragment, {
                  children: [
                    React.cloneElement(artistId$1 !== undefined ? JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, undefined, undefined, undefined, undefined, {
                        artistId: artistId$1
                      }, undefined, "/artist/$artistId", undefined)) : JsxRuntime.jsx("span", {}), {
                      children: song.artist
                    }),
                    JsxRuntime.jsx("span", {
                      children: " – ",
                      "aria-hidden": true
                    })
                  ]
                });
              }
              tmp$2 = JsxRuntime.jsxs("div", {
                children: [
                  tmp$3,
                  JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps("Album", Caml_option.some(song.album), undefined, undefined, undefined, {
                    albumId: song.albumId
                  }, undefined, "/album/$albumId", undefined))
                ],
                className: css.subtitle
              });
            } else {
              tmp$2 = JsxRuntime.jsx(Shared__Skeleton.make, {
                style: {
                  maxWidth: "10rem"
                }
              });
            }
            return JsxRuntime.jsxs(React.Fragment, {
              children: [
                tmp,
                tmp$2
              ]
            });
          }),
          selector: (function (state) {
            return Stdlib__Option.bind(songId, (function (songId) {
              return Caml_option.undefined_to_opt(state.songs.byId.get(songId));
            }));
          })
        }),
        className: css.title
      }),
      JsxRuntime.jsx(Store__Context.Consumer.make, {
        children: (function (song) {
          let tmp = {
            className: css.starButton,
            disabled: Stdlib__Option.is_none(song)
          };
          const tmp$1 = Stdlib__Option.map((function (song) {
            return song.id;
          }), song);
          if (tmp$1 !== undefined) {
            tmp.id = Caml_option.valFromOption(tmp$1);
          }
          const tmp$2 = Stdlib__Option.bind(song, (function (song) {
            return song.starred;
          }));
          if (tmp$2 !== undefined) {
            tmp.starred = Caml_option.valFromOption(tmp$2);
          }
          return JsxRuntime.jsx(Shared__StarButton.make, tmp);
        }),
        selector: (function (state) {
          return Stdlib__Option.bind(songId, (function (songId) {
            return Caml_option.undefined_to_opt(state.songs.byId.get(songId));
          }));
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Store__Context.Consumer.make, {
            children: (function (song) {
              return JsxRuntime.jsx("span", {
                children: song !== undefined ? Shared__Duration.format(song.duration) : JsxRuntime.jsx(Shared__Skeleton.make, {
                    className: css.durationSkeleton
                  }),
                "aria-label": "Duration",
                className: css.duration
              });
            }),
            selector: (function (state) {
              return Stdlib__Option.bind(songId, (function (songId) {
                return Caml_option.undefined_to_opt(state.songs.byId.get(songId));
              }));
            })
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs(Shared__DropdownMenu.Root.make, {
              children: [
                JsxRuntime.jsx(Shared__DropdownMenu.Trigger.make, {
                  children: JsxRuntime.jsx(Shared__Button.make, {
                    ariaLabel: "Song menu",
                    children: JsxRuntime.jsx(LucideReact$1.Ellipsis, Curry._4(LucideReact.Ellipsis.makeProps, undefined, undefined, "none", undefined)),
                    className: css.menuButton,
                    variant: "icon"
                  })
                }),
                JsxRuntime.jsxs(Shared__DropdownMenu.Content.make, {
                  children: [
                    JsxRuntime.jsxs(Shared__DropdownMenu.Item.make, {
                      children: [
                        JsxRuntime.jsx(LucideReact$1.Play, Curry._4(LucideReact.Play.makeProps, undefined, undefined, "none", undefined)),
                        "Play now"
                      ],
                      onClick: (function (param) {
                        const songId$1 = Stdlib__Option.get(songId);
                        Curry._1(runAsyncStoreFx, Fx.bind(Fx.ask(undefined), (function (param) {
                          const state = param.store.getState();
                          const newSongIds = state.player.queuedSongIds.filter(function (id) {
                            return id !== songId$1;
                          });
                          const current = state.player.currentSongId;
                          const index = current !== undefined ? newSongIds.indexOf(current, undefined) : 0;
                          newSongIds.splice(index, 0, songId$1);
                          return StoreFx__StartPlaying.make(songId$1, newSongIds, undefined);
                        }))).then(function (result) {
                          return Promise.resolve(Stdlib__Result.get_ok(result));
                        });
                      })
                    }),
                    JsxRuntime.jsxs(Shared__DropdownMenu.Item.make, {
                      children: [
                        JsxRuntime.jsx(LucideReact$1.ListStart, Curry._4(LucideReact.ListStart.makeProps, undefined, undefined, "none", undefined)),
                        "Play next"
                      ],
                      onClick: (function (param) {
                        const songId$1 = Stdlib__Option.get(songId);
                        Curry._1(runAsyncStoreFx, Fx.bind(Fx.ask(undefined), (function (param) {
                          const state = param.store.getState();
                          const current = state.player.currentSongId;
                          const queued = state.player.queuedSongIds;
                          const songIdIsSameAsCurrent = current !== undefined ? songId$1 === current : false;
                          if (songIdIsSameAsCurrent) {
                            const currentIndex = current !== undefined ? queued.indexOf(current, undefined) : 0;
                            const newSongIds = queued.filter(function (id) {
                              return id !== songId$1;
                            });
                            newSongIds.splice(currentIndex + 1 | 0, 0, songId$1);
                            return StoreFx__StartPlaying.make(newSongIds[currentIndex], newSongIds, undefined);
                          }
                          const newSongIds$1 = queued.filter(function (id) {
                            return id !== songId$1;
                          });
                          newSongIds$1.splice((
                            current !== undefined ? newSongIds$1.indexOf(current, undefined) : 0
                          ) + 1 | 0, 0, songId$1);
                          return StoreFx__StartPlaying.make(Stdlib__Option.value(current, songId$1), newSongIds$1, undefined);
                        }))).then(function (result) {
                          return Promise.resolve(Stdlib__Result.get_ok(result));
                        });
                      })
                    }),
                    JsxRuntime.jsxs(Shared__DropdownMenu.Item.make, {
                      children: [
                        JsxRuntime.jsx(LucideReact$1.ListEnd, Curry._4(LucideReact.ListEnd.makeProps, undefined, undefined, "none", undefined)),
                        "Play last"
                      ],
                      onClick: (function (param) {
                        const songId$1 = Stdlib__Option.get(songId);
                        Curry._1(runAsyncStoreFx, Fx.bind(Fx.ask(undefined), (function (param) {
                          const state = param.store.getState();
                          const current = state.player.currentSongId;
                          const songIdIsSameAsCurrent = current !== undefined ? songId$1 === current : false;
                          const queued = state.player.queuedSongIds.filter(function (id) {
                            return id !== songId$1;
                          }).concat([songId$1]);
                          let tmp;
                          if (songIdIsSameAsCurrent) {
                            const len = state.player.queuedSongIds.length;
                            const index = Caml_int32.mod_(state.player.queuedSongIds.indexOf(Stdlib__Option.get(state.player.currentSongId), undefined) + 1 | 0, len);
                            tmp = state.player.queuedSongIds[index];
                          } else {
                            const arg = state.player.queuedSongIds[0];
                            tmp = (function (param) {
                              return Stdlib__Option.value(param, arg);
                            })(state.player.currentSongId);
                          }
                          return StoreFx__StartPlaying.make(tmp, queued, undefined);
                        }))).then(function (result) {
                          return Promise.resolve(Stdlib__Result.get_ok(result));
                        });
                      })
                    }),
                    JsxRuntime.jsxs(Shared__DropdownMenu.Item.make, {
                      children: [
                        JsxRuntime.jsx(LucideReact$1.ListPlus, Curry._4(LucideReact.ListPlus.makeProps, undefined, undefined, "none", undefined)),
                        "Add to Playlist…"
                      ],
                      onClick: (function (param) {
                        window.alert("TODO");
                      })
                    }),
                    JsxRuntime.jsxs(Shared__DropdownMenu.Item.make, {
                      children: [
                        JsxRuntime.jsx(LucideReact$1.Info, Curry._4(LucideReact.Info.makeProps, undefined, undefined, "none", undefined)),
                        "Info"
                      ],
                      onClick: (function (param) {
                        window.alert("TODO");
                      })
                    }),
                    JsxRuntime.jsxs(Shared__DropdownMenu.Item.make, {
                      children: [
                        JsxRuntime.jsx(LucideReact$1.Download, Curry._4(LucideReact.Download.makeProps, undefined, undefined, "none", undefined)),
                        "Download"
                      ],
                      onClick: (function (param) {
                        window.alert("TODO");
                      })
                    })
                  ],
                  placement: "bottomEnd"
                })
              ]
            }),
            className: css.menu
          })
        ],
        className: css.durationMenuCol
      }),
      isQueueView ? JsxRuntime.jsx(Shared__Button.make, {
          ariaLabel: "Remove from queue",
          children: JsxRuntime.jsx(LucideReact$1.Trash2, Curry._4(LucideReact.Trash2.makeProps, undefined, undefined, "none", undefined)),
          className: css.removeFromQueueButton,
          variant: "icon",
          onClick: (function (param) {
            $$Promise.Monad_syntax.let$star(Curry._1(runAsyncStoreFx, StoreFx__UpdatePlayQueue.make(function (state) {
              return {
                current: state.current,
                currentTime: state.currentTime,
                queued: state.queued.filter(function (id) {
                  return id !== songId;
                })
              };
            })), (function (result) {
              return Promise.resolve(Stdlib__Result.get_ok(result));
            }));
          })
        }) : null
    ],
    "aria-label": "Song",
    className: Clsx(css.root, isAlbumView ? css.root_albumView : undefined, isCurrentInPlayer ? css.root_isCurrentInPlayer : undefined, paused ? css.root_paused : undefined, isSelected ? css.root_selected : undefined)
  };
  if (elementId !== undefined) {
    tmp.id = Caml_option.valFromOption(elementId);
  }
  return JsxRuntime.jsxs("div", tmp);
});

export {
  make,
}
/* css Not a pure module */
